import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Drawer, Grid2 } from "@mui/material";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { ClosingChecklistListTypeEnum } from "../../../_common/enum/closingChecklistListType.enum";
import { ValidatorForm } from "react-material-ui-form-validator";
import { DataTypeAutoComplete } from "../../../_components/autocomplete/dataType.autocomplete";
import { StandardButton } from "../../../_components/button/primary.button";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import { ticketClosingChecklistService } from "../../../_services/ticketClosingChecklist.service";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { toastr } from "../../../_components/toastr/toastr";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";

export const TicketClosingChecklistAgentDrawer = (params: { isOpen?: boolean, onSave(): void, onClose(): void, closingChecklistListTypeId: ClosingChecklistListTypeEnum }) => {

    const resetData = () => ({});

    const { id, checklistItemId, ticketAgentId } = useParams<{ id: string, checklistItemId?: string, ticketAgentId: string }>();
    const [data, setData] = useState<any>(resetData);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [saving, setIsSaving] = useState(false);
    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {
        if (isOpen == false)
            setIsOpen(true);
    }, []);

    useEffect(() => {
        if (checklistItemId != null) fetchData();
        else setData({});
    }, [checklistItemId]);

    function fetchData() {
        if (!checklistItemId) {
            setIsLoading(false);
            return;
        };

        setIsLoading(true);
        return ticketClosingChecklistService
            .get(checklistItemId || "0")
            .then(
                (json) => {
                    setData(json);

                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        const _data = { ...data, ticketId: id, ticketAgentId: ticketAgentId, closingChecklistListTypeId: params.closingChecklistListTypeId, };

        console.log("Submitting data:", _data);

        return ticketClosingChecklistService
            .submit(_data)
            .then(
                () => {
                    toastr.success("Saved successfully");

                    if (!!params.onSave)
                        params.onSave();
                },
                handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }


    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }));
    }

    return (
        <Drawer
            anchor={"right"}
            variant="persistent"
            open={isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <DrawerHeader name={"Closing Checklist Agent"} onClose={params.onClose} />

            <ValidatorForm onSubmit={submit} noValidate style={{ padding: "4px" }}>
                <Grid2 container spacing={2}>
                    {checklistItemId == null &&
                        <Grid2 size={{ xs: 12 }}>
                            <DataTypeAutoComplete
                                key="closingChecklistTypeId"
                                dataType={DataTypeEnum.ClosingChecklistTypes}
                                label="Select Closing Checklist Type"
                                hasParent={false}
                                value={data.closingChecklistTypeId}
                                name={"closingChecklistTypeId"}
                                onChange={handleChange}
                                required={true}
                            />
                        </Grid2>
                    }

                    {checklistItemId != null &&
                        <Grid2 size={{ xs: 12 }}>
                            <StandardTextValidator
                                key="name"
                                name="name"
                                label="Closing Checklist Type"
                                fullWidth
                                disabled
                                value={data.name}
                            />
                        </Grid2>
                    }

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="quantity"
                            name="quantity"
                            label="Quantity"
                            required
                            fullWidth
                            type="number"
                            validators={['required', 'minNumber:1']}
                            errorMessages={['Quantity is required', 'Quantity must be at least 1']}
                            value={data.quantity}
                            onChange={handleChange}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            key="price"
                            name="price"
                            label="Price"
                            fullWidth
                            type="number"
                            value={data.price}
                            onChange={handleChange}

                        />
                    </Grid2>

                    <Grid2 size={{ xs: 6 }}>
                        <StandardButton
                            saving={saving}
                            loading={isLoading}
                            icon="save"
                            type="submit"
                        >
                            Save
                        </StandardButton>
                    </Grid2>

                    <Grid2 size={{ xs: 6 }}>
                        <StandardButton
                            saving={saving}
                            loading={isLoading}
                            icon="block"
                            variant="error"
                            onClick={() => { navigate(-1) }}>
                            Cancel
                        </StandardButton>
                    </Grid2>
                </Grid2>
            </ValidatorForm>
        </Drawer >



    );

}